/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Filter_AnyInputs */

const cs_calendar_filter_any = /** @type {(inputs: Calendar_Filter_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jakékoli`)
};

const en_calendar_filter_any = /** @type {(inputs: Calendar_Filter_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any`)
};

/**
* | output |
* | --- |
* | "Any" |
*
* @param {Calendar_Filter_AnyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_filter_any = /** @type {((inputs?: Calendar_Filter_AnyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Filter_AnyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_filter_any(inputs)
	return cs_calendar_filter_any(inputs)
});